module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjI4IiB2aWV3Qm94PSIwIDAgNDggMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJTd2l0Y2gvdHJ1ZS8mIzIzNDsmIzE4NDsmIzE3NjsmIzIzNTsmIzE3OTsmIzE4NDsiPgo8cmVjdCB3aWR0aD0iNDgiIGhlaWdodD0iMjgiIHJ4PSIxNCIgZmlsbD0iIzAwOTZGRiIvPgo8Y2lyY2xlIGlkPSJFbGxpcHNlIDQiIGN4PSIzNCIgY3k9IjE0IiByPSIxMCIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_switch_on.svg
// module id = lhET
// module chunks = 1